import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { InvoiceLine, InvoiceLineType, SearchInvoiceLine } from '../../models/models';

@Component({
    selector: 'invoice-line-form',
    templateUrl: './invoice-line-form.component.html',
    standalone: false
})
export class InvoiceLineForm implements OnChanges {
    @Input() invoiceLine: InvoiceLine = {} as InvoiceLine;
    @Input() pageType: string = "";
    @Output() onRefresh = new EventEmitter<any>();

    public invoiceLineTypeListOrig: InvoiceLineType[] = [];
    public invoiceLineTypeList: InvoiceLineType[] = [];
    public invoiceLineList: SearchInvoiceLine[] = [];
    public isLoading: boolean = false;

    constructor(private orderService: OrderService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        //console.log("ngOnInit", this.invoiceLine);
    }

    ngOnChanges() {
        this.getInvoiceLineTypes();
        this.getInvoiceLines();
    }

    private getInvoiceLineTypes() {
        this.orderService.getInvoiceLineTypes().subscribe(result => {
            this.invoiceLineTypeListOrig = result;
            var accessorialList = this.invoiceLineTypeListOrig.filter(t => t.accessorialCharge == true);
            var nonAccessorialList = this.invoiceLineTypeListOrig.filter(t => t.accessorialCharge != true);
            var isEdit: boolean = this.invoiceLine.invoiceLineID > 0;
            var thisAccessorial = this.invoiceLineTypeListOrig.find(t => t.invoiceLineTypeID == this.invoiceLine.invoiceLineTypeID);

            if (!isEdit || thisAccessorial != null && thisAccessorial.accessorialCharge == true) {
                this.invoiceLineTypeList = accessorialList;
            }
            else {
                this.invoiceLineTypeList = nonAccessorialList;
            }

            this.invoiceLineTypeList = this.invoiceLineTypeList.sort((left, right): number => {
                if (left.abbrev < right.abbrev) return -1;
                if (left.abbrev > right.abbrev) return 1;
                return 0;
            });


            if (this.invoiceLineList.length > 0) {
                this.checkMissingLinhaul();
            }
        });
        //console.log("ngOnChanges", this.invoiceLine);
    }

    private getInvoiceLines() {
        this.utilService.isLoading = true;
        this.orderService.getSearchInvoiceLineByQuoteOrderID(this.invoiceLine.quoteOrderID).subscribe(result => {
            this.utilService.isLoading = false;
            this.invoiceLineList = result.resultCollection;
            if (this.invoiceLineTypeListOrig.length > 0) {
                this.checkMissingLinhaul();
            }
        });
    }

    private checkMissingLinhaul() {
        var lhaul = this.invoiceLineList.find(t => t.abbrev == "LHaul");
        if (lhaul == null || lhaul.invoiceAmount == 0) {
            var lhaulType = this.invoiceLineTypeListOrig.find(t => t.abbrev == "LHaul");
            var currTypeLhaul = this.invoiceLineTypeList.find(t => t.abbrev == "LHaul");
            if (lhaulType != null && currTypeLhaul == null) {
                // Add LHaul to list for dropdown option
                this.invoiceLineTypeList.push(lhaulType);
                this.invoiceLineTypeList = this.invoiceLineTypeList.sort((left, right): number => {
                    if (left.abbrev < right.abbrev) return -1;
                    if (left.abbrev > right.abbrev) return 1;
                    return 0;
                });
            }
            //this.notificationService.showWarning("Invoice Lines Line Haul (LHaul) missing or $0.00.", "WARNING: Add Invoice Line");
        }
    }

    public calcAmount() {
        if (!isNaN(this.invoiceLine.quantity) && !isNaN(this.invoiceLine.rate)) {
            this.invoiceLine.rate = Math.round((this.invoiceLine.rate + Number.EPSILON) * 100) / 100;
            this.invoiceLine.invoiceAmount = this.invoiceLine.quantity * this.invoiceLine.rate;
            this.invoiceLine.invoiceAmount = Math.round((this.invoiceLine.invoiceAmount + Number.EPSILON) * 100) / 100;
        }
    }

    public save() {
        this.isLoading = true;
        console.log("save", this.invoiceLine);
        this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Invoice Line Form Save");
        this.orderService.saveInvoiceLine(this.invoiceLine).subscribe(result => {
            this.isLoading = false;
            if (result.invoiceLineID > 0) {
                //this.getCustomers();
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.invoiceLine = {} as InvoiceLine;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
